import * as React from "react"
import { Modal } from "antd"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEye } from "@fortawesome/free-solid-svg-icons"
import "./index.scss"
import { PreFraudModalView } from "./PreFraudModalView"
import Tooltip from "../Tooltip/Tooltip"
import { ITrade } from "src/services/interfaces/trade/ITrade"
interface IPreFraudButtonProps {
  trade?: ITrade,
  hidenAsAChildren?: (trade?: ITrade) => boolean;
}

export const PreFraudButton: React.FC<IPreFraudButtonProps> = ({ trade }) => {
  const [showModal, setShowModal] = React.useState<boolean>(false);

  return (
    <>
      <Tooltip text="Visualizar Link de Selfie">
        <button
          className="view-fraud btn"
          onClick={() => setShowModal(true)}
        >
          <FontAwesomeIcon icon={faEye} />
          Link de Selfie
        </button>
      </Tooltip>

      <Modal
        className="prefraud-modal"
        title="Visualizar processo de selfie"
        visible={showModal}
        onOk={() => setShowModal(false)}
        onCancel={() => setShowModal(false)}
      >
        {showModal && <PreFraudModalView tradeId={trade.id} />}
      </Modal>
    </>
  )
}

export default PreFraudButton



// WEBPACK FOOTER //
// ./src/components/common/PreFraudView/ViewPreFraudButton.tsx